// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PjJJ","col":"styles_col__1cLxf","actions":"styles_actions__3rGoN","conflict":"styles_conflict__10U_x"};